import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LandingLayoutComponent } from './layouts';
import { FooterComponent, HeaderComponent } from './components';
import { DetectInViewDirective, FadeIntoViewDirective } from './directives';

const COMPONENTS = [
  HeaderComponent,
  FooterComponent,
];

const LAYOUTS = [
  LandingLayoutComponent,
];

const DIRECTIVES = [
  FadeIntoViewDirective,
  DetectInViewDirective,
];

@NgModule({
  declarations: [...COMPONENTS, ...LAYOUTS, ...DIRECTIVES],
  exports: [...COMPONENTS, ...LAYOUTS, ...DIRECTIVES],
  imports: [
    CommonModule,
    RouterModule,
  ],
})
export class ThemeModule {}
